import { AppConfig } from "../constants/config";
import { getJson } from "../utils/httpHelper";

export const getGoogleFonts = async () => {
  const response = await fetch(
    `https://www.googleapis.com/webfonts/v1/webfonts?key=${AppConfig.googleAPIKey}&sort=popularity`
  );
  return getJson(response);
};
